import type { Client } from '../../api/client.js';
import { COULEURS } from '../../app/styles.js';
import { STATUTS_DEVOLUTION } from './libelles.js';
import { COLONNES_VIVANTS, lignesVivants } from './tableaux.js';
import type { DonneesArbre } from './types.js';

export interface ExportNotaire {
  colonnes: string[];
  lignes: string[][];
}

/**
 * Export pour le notaire : exactement les colonnes du tableau des vivants (#11), dans le même ordre ; l'intitulé de la
 * colonne Droits porte le statut du résultat juridique (« à valider notaire », SYNTHESE §2). Seules les coordonnées de
 * visibilité notaire ou famille sortent ; les autres sont remplacées par « non communiqué ».
 */
export function exportNotaire(d: DonneesArbre): ExportNotaire {
  return {
    colonnes: COLONNES_VIVANTS.map((c) => (c.libelle === 'Droits' ? STATUTS_DEVOLUTION[d.devolution.status].colonne : c.libelle)),
    lignes: lignesVivants(d, 'notaire').map((l) => COLONNES_VIVANTS.map((c) => l.cellules[c.libelle] ?? '')),
  };
}

const proteger = (cellule: string): string => (/[;"\r\n]/.test(cellule) ? `"${cellule.replace(/"/g, '""')}"` : cellule);

/** CSV à points-virgules (ouverture directe dans un tableur français), fins de ligne CRLF. */
export function versCsv(e: ExportNotaire): string {
  return [e.colonnes, ...e.lignes].map((ligne) => ligne.map(proteger).join(';')).join('\r\n');
}

/** Export officiel : le PDF du tableau des vivants, produit et audité par le serveur (`tableaux.export`). */
export function demanderPdf(client: Pick<Client, 'appeler'>, dossierId: string): Promise<unknown> {
  return client.appeler('genealogie.tableaux.exporter', {
    parametres: { dossierId },
    requete: { tableau: 'vivants', format: 'pdf' },
  });
}

export function BoutonExportNotaire({ exporter, enCours = false }: { exporter: () => Promise<unknown> | void; enCours?: boolean }) {
  return (
    <button
      type="button"
      disabled={enCours}
      onClick={() => {
        void exporter();
      }}
      style={{
        minHeight: 44,
        padding: '0 16px',
        borderRadius: 8,
        border: `1px solid ${COULEURS.marine}`,
        background: COULEURS.marine,
        color: COULEURS.blanc,
        font: 'inherit',
        cursor: 'pointer',
      }}
    >
      Exporter pour le notaire
    </button>
  );
}
